module.exports = __webpack_public_path__ + "static/media/NationalPark.ddccb1fc.png";